export default "__VITE_ASSET__ca1c4e10__"